import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { PurchaseReceiptsReport, StockItemAmendment, StockItemHeaderReceipt } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class StockItemHeaderReceiptService extends TmsWebBaseEditCreateService<
  StockItemHeaderReceipt,
  StockItemHeaderReceipt
> {
  public refreshDetails = new Subject<StockItemHeaderReceipt>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('StockItemHeaderReceipt', $localize`Stock Item Header Receipt`, httpService, notificationService);
  }

  amendStockAlreadyReceived(stockItemAmendment: StockItemAmendment): Observable<StockItemHeaderReceipt> {
    return this.httpService.post<StockItemHeaderReceipt>(
      `${this.apiUrl}/AmendStockAlreadyReceived`,
      stockItemAmendment,
    );
  }

  multiReceiveStock(ids: string[], quantities: number[]): Observable<string[]> {
    return this.httpService.post<string[]>(`${this.apiUrl}/MultiReceiveStock`, { ids, quantities });
  }

  stockReceivedPurchaseOrder(id: string): Observable<StockItemHeaderReceipt> {
    return this.httpService.get<StockItemHeaderReceipt>(
      `${this.apiUrl}/StockReceiptsPurchaseOrder?purchaseOrderLineId=${id}`,
    );
  }

  purchaseReceiptReport(deliveryNote: string): Observable<PurchaseReceiptsReport> {
    return this.httpService.get<PurchaseReceiptsReport>(
      `${this.apiUrl}/PurchaseReceiptReport?deliveryNote=${deliveryNote}`,
    );
  }

  relocateCallOff(purchaseOrderLineId: string, comments: string, ids: string[], quantity: number[]): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/RelocateCallOff`, {
      purchaseOrderLineId,
      comments,
      ids,
      quantity,
    });
  }
}
